import {Component, OnInit, ViewChild} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {Router} from '@angular/router';
import {SessionService} from '../services/session.service';
import {ClientContractsComponent} from '../components/lists/client-contracts/client-contracts.component';
import {SortDirection} from "@aws-amplify/datastore";

@Component({
    selector: 'app-my-investments',
    templateUrl: './my-investments.page.html',
    styleUrls: ['./my-investments.page.scss'],
})
export class MyInvestmentsPage implements OnInit {
    @ViewChild('contractsListCmp') contractsListCmp: ClientContractsComponent;

    profile = 'education';
    showFilters = false;
    sortAscendent = SortDirection.ASCENDING;
    sort = SortDirection;
    filters = {
        name: '',
        sort: this.sortAscendent,
        filterBy: 'startDate',
    };
    scadenza: any;

    constructor(
        private navController: NavController,
        public router: Router,
        public sessionService: SessionService,
    ) {
    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    back() {
        this.navController.back();
    }

    async filterContracts() {
        this.filters.sort = this.sortAscendent;

        await this.contractsListCmp.filterContracts(this.filters);
    }

    changeSort() {
        this.sortAscendent === SortDirection.ASCENDING ? this.sortAscendent = SortDirection.DESCENDING : this.sortAscendent = SortDirection.ASCENDING;
        this.filterContracts();
    }

}
